import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: 'How long does the trademark registration process take?',
      answer: 'The full trademark journey generally takes 8–12 months from submission to final approval. This includes initial filing, USPTO review, publication for opposition, and final registration. Our team provides continuous updates at every stage so you stay informed.'
    },
    {
      question: 'What is the difference between ™ and ® symbols?',
      answer: 'The ™ symbol can be used for an unregistered trademark claim, while ® is only allowed once your trademark is officially registered with the USPTO, confirming legal protection.'
    },
    {
      question: 'Do I need a trademark attorney?',
      answer: 'While not mandatory, working with a trademark attorney greatly increases your chances of approval by ensuring accurate filing, proper classification, and legal compliance.'
    },
    {
      question: 'What if my trademark application is rejected?',
      answer: 'If your application faces rejection, we assist in analyzing the issue, preparing responses, and taking corrective legal steps to improve your chances of approval.'
    },
    {
      question: 'Can I trademark a business name that is already a domain?',
      answer: 'Yes, domain ownership does not automatically grant trademark rights. We evaluate whether your business name is legally available for trademark protection.'
    },
    {
      question: 'What classes should I file under?',
      answer: 'Trademark classes depend on your goods or services. Our experts identify the most suitable classification to ensure your brand is fully protected.'
    },
    {
      question: 'Do you offer international trademark registration?',
      answer: 'Yes, we provide guidance and support for international trademark protection through relevant global filing systems based on your business needs.'
    },
    {
      question: 'What happens after my trademark is registered?',
      answer: 'After registration, your trademark receives legal protection, and we recommend ongoing monitoring to prevent infringement and maintain your rights effectively.'
    }
  ];

  return (
    <div className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600">
            Everything you need to understand about trademark registration with Global Trademark Filer
          </p>
        </div>

        {/* Two Column Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                className="w-full px-6 py-4 flex items-center justify-between hover:bg-gray-100 transition-colors"
              >
                <span className="text-left font-semibold text-black pr-8 text-sm">
                  {faq.question}
                </span>
                <ChevronDown
                  className={`w-5 h-5 text-[#168356] flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'transform rotate-180' : ''}`}
                />
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96' : 'max-h-0'}`}
              >
                <div className="px-6 pb-4 text-gray-700 leading-relaxed text-sm">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQSection;